import React from "react";

/**
 * NumberedItem — editorial grid cell.
 * Thin top rule, eyebrow number in gold, then name + optional description.
 */
export const NumberedItem = ({
  index,
  name,
  body,
  tone = "onLight",
  ruleColor,
  className = "",
}) => {
  const isDark = tone === "onDark";
  const textColor = isDark ? "text-offwhite" : "text-navy";
  const bodyColor = isDark ? "text-offwhite/70" : "text-navy/70";
  const ruleClass =
    ruleColor || (isDark ? "bg-offwhite/15" : "bg-navy/12");

  const numberLabel = String(index).padStart(2, "0") + ".";

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <span aria-hidden="true" className={`block h-px w-12 ${ruleClass}`} />
      <span className="font-sans text-[11px] uppercase tracking-eyebrow text-gold">
        {numberLabel}
      </span>
      <h3 className={`font-serif text-2xl sm:text-3xl leading-tight ${textColor}`}>
        {name}
      </h3>
      {body ? (
        <p className={`font-sans text-[15px] leading-[1.7] max-w-[44ch] ${bodyColor}`}>
          {body}
        </p>
      ) : null}
    </div>
  );
};

export default NumberedItem;
